<template>
  <td>
    <button v-if="dataItem.referenceID" type="button" class="k-primary k-button k-grid-edit-command" @click="viewHandler">View</button>
    <button v-if="dataItem.referenceID"
      type="button"
      class="btn-info k-button k-grid-edit-command"
      @click="downloadtHandler"
    >Download</button>
    <button
      type="button"
      class="btn-danger k-button k-grid-remove-command"
      @click="removeHandler"
    >Delete</button>
  </td>
</template>
 
<script>
export default {
  props: {
    dataItem: Object,
    columnIndex: Number
  },
  watch: {
    dataItem: function(newVal) {
      this.item = newVal;
    }
  },
  methods: {
    viewHandler: function() {
      this.$emit("view", { dataItem: this.item });
    },
    downloadtHandler() {
      this.$emit("download", { dataItem: this.item });
    },
    removeHandler: function() {
      this.$emit("remove", { dataItem: this.item });
    }
  },
  data: function() {
    return {
      item: { ...this.dataItem }
    };
  }
};
</script>
 
<style>
</style>